import React, { useState } from "react";
import "./ProteinFAQ.css"; // Make sure to import the CSS for styling

const ProteinFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqData = [
    {
      question: "How much protein do I need to build muscle?",
      answer:
        "The general recommendation is 1.2 to 2.2 grams of protein per kilogram of body weight, depending on your workout intensity and goals. For example, if you weigh 70kg and are working out intensely, you should aim for 140-154g of protein per day.",
    },
    {
      question: "What is the best protein intake for muscle gain?",
      answer:
        "A protein intake of 1.2 to 2.2 grams per kilogram of body weight is generally recommended for muscle gain. Your specific needs may vary depending on your workout intensity and personal goals.",
    },
    {
      question:
        "How much protein should I eat after a workout for muscle recovery?",
      answer:
        "For optimal muscle recovery, aim for 20-30 grams of protein within 30 minutes to 2 hours after your workout. This helps kickstart muscle repair and growth when your muscles are most receptive to nutrients.",
    },
    {
      question: "What is the ideal protein-to-carb ratio for muscle gain?",
      answer:
        "A balanced ratio for muscle gain is typically around 40% protein, 40% carbs, and 20% fats. However, this can vary based on individual goals, activity levels, and metabolic responses. Adjusting your macros based on your progress is key.",
    },
    {
      question: "Can I build muscle on a plant-based diet with protein?",
      answer:
        "Yes! There are plenty of plant-based protein sources such as lentils, quinoa, tofu, edamame, tempeh, and plant-based protein powders. With proper planning, you can meet all your protein needs on a vegan or vegetarian diet.",
    },
    {
      question: "How does protein intake affect muscle growth?",
      answer:
        "Protein is essential for muscle growth as it provides the amino acids required for muscle repair and building. Adequate protein intake, combined with strength training, supports muscle recovery and growth.",
    },
    {
      question: "Is there a protein intake calculator for muscle gain?",
      answer:
        "Yes, there are many online protein calculators that estimate your daily protein needs based on your weight, workout intensity, and goals. These calculators can help you determine how much protein to consume for muscle gain.",
    },
    {
      question:
        "What is the recommended protein intake for muscle gain in women?",
      answer:
        "Women typically require 1.2 to 2.0 grams of protein per kilogram of body weight for muscle gain, depending on their activity levels and goals. Protein intake should be spread evenly across meals throughout the day.",
    },
    {
      question: "How do I calculate my protein intake for building muscle?",
      answer:
        "To calculate your protein intake, multiply your weight in kilograms by a factor of 1.2 to 2.2 (depending on workout intensity). For example, if you weigh 70kg and aim for 1.5g of protein per kg, you would need 105g of protein per day.",
    },
    {
      question: "How much protein do I need to gain muscle mass?",
      answer:
        "To gain muscle mass, aim for 1.6 to 2.2 grams of protein per kilogram of body weight daily. Adjust the amount based on your workout intensity, progress, and goals.",
    },
    {
      question: "What is the best protein source for building muscle?",
      answer:
        "Whey protein is often considered the best for muscle building due to its high digestibility and amino acid profile. However, other high-quality options like casein, eggs, lean meats, and plant-based proteins like pea and soy are also excellent choices.",
    },
    {
      question: "Can protein intake alone help me build muscle?",
      answer:
        "While protein is essential for muscle growth, it’s important to also engage in a proper strength training regimen. Consistent resistance training combined with adequate protein intake leads to optimal muscle growth.",
    },
    {
      question:
        "How much protein is required for muscle recovery after a workout?",
      answer:
        "Aim for 20-30 grams of protein post-workout to promote muscle recovery and protein synthesis. This helps repair muscle fibers that are broken down during exercise.",
    },
    {
      question: "What happens if I consume too much protein for muscle gain?",
      answer:
        "Excessive protein may not provide additional muscle-building benefits and could put strain on your kidneys over time. It's important to stay within the recommended protein range (1.2 to 2.2g per kg of body weight) to avoid any adverse effects.",
    },
    {
      question: "How often should I consume protein to build muscle?",
      answer:
        "It’s ideal to consume protein throughout the day, aiming for at least 20-30 grams of protein every 3-4 hours. This helps maintain a steady supply of amino acids for muscle repair and growth.",
    },
    {
      question: "What are the best protein-rich foods for muscle gain?",
      answer:
        "High-quality protein sources include lean meats, poultry, fish, eggs, dairy products, legumes, tofu, and protein powders like whey or plant-based options.",
    },
    {
      question:
        "How can I use a protein intake calculator for muscle building?",
      answer:
        "Protein intake calculators can help you estimate how much protein you need based on your weight, activity level, and fitness goals. They can guide you in ensuring you're consuming enough protein to support muscle growth.",
    },
    {
      question: "Can I consume protein in the morning to build muscle?",
      answer:
        "Yes, consuming protein in the morning is a great way to kickstart muscle repair and provide your body with the necessary amino acids after a night's fast.",
    },
    {
      question:
        "How much protein should I consume if I’m doing resistance training?",
      answer:
        "If you're engaging in resistance training, aim for 1.6 to 2.2 grams of protein per kilogram of body weight. This helps ensure muscle repair and growth during recovery.",
    },
    {
      question: "What’s the effect of protein timing on muscle building?",
      answer:
        "Protein timing, such as consuming protein before and after workouts, can be beneficial for muscle recovery and growth. The post-workout window (30 minutes to 2 hours) is particularly important for replenishing muscle stores and promoting muscle protein synthesis.",
    },
    {
      question:
        "Is it necessary to consume protein before a workout for muscle gain?",
      answer:
        "While not absolutely necessary, consuming protein before a workout can provide your body with amino acids for energy and help reduce muscle breakdown during exercise.",
    },
    {
      question:
        "How much protein do I need for muscle gain if I’m doing CrossFit?",
      answer:
        "For CrossFit or high-intensity training, aim for 1.6 to 2.2 grams of protein per kilogram of body weight to support muscle repair and prevent muscle loss.",
    },
    {
      question:
        "How much protein do I need for muscle gain in a calorie deficit?",
      answer:
        "Even in a calorie deficit, it's crucial to maintain a higher protein intake (1.6 to 2.2 grams per kilogram of body weight) to preserve muscle mass while losing fat.",
    },
    {
      question: "Can protein intake help with fat loss while building muscle?",
      answer:
        "Yes, a high-protein diet can help you preserve muscle mass while in a calorie deficit for fat loss. Protein helps maintain muscle tissue and can also make you feel fuller for longer, reducing overall calorie intake.",
    },
    {
      question: "What’s the best protein powders for muscle gain?",
      answer:
        "Whey protein isolate, casein protein, and plant-based proteins like pea and soy protein are some of the best choices for muscle gain, offering high bioavailability and amino acid profiles.",
    },
    {
      question: "Is whey protein the best for muscle gain?",
      answer:
        "Whey protein is often considered the best due to its fast absorption and high amino acid content. It's particularly effective for post-workout recovery and muscle repair.",
    },
    {
      question:
        "What’s the difference between protein and amino acids for muscle growth?",
      answer:
        "Proteins are made up of amino acids, which are the building blocks for muscle repair and growth. Essential amino acids, especially leucine, play a significant role in stimulating muscle protein synthesis.",
    },
    {
      question:
        "Should I take protein before or after my workout for muscle gain?",
      answer:
        "Both pre- and post-workout protein can support muscle gain. Pre-workout protein provides amino acids during exercise, while post-workout protein accelerates recovery and muscle repair.",
    },
    {
      question:
        "How do I calculate protein intake for weight loss and muscle gain?",
      answer:
        "To calculate protein intake for weight loss and muscle gain, aim for 1.6 to 2.2 grams per kilogram of body weight to support muscle preservation while in a calorie deficit.",
    },
    {
      question: "Can I calculate my protein intake based on my weight?",
      answer:
        "Yes, simply multiply your weight in kilograms by a factor of 1.2 to 2.2 depending on your workout intensity. This will give you a target range for your daily protein intake.",
    },
    {
      question:
        "What’s the ideal protein intake for building muscle without gaining fat?",
      answer:
        "The ideal protein intake for building muscle without gaining fat is typically 1.6 to 2.2 grams per kilogram of body weight, combined with a balanced diet and proper strength training.",
    },
    {
      question:
        "How do I adjust protein intake when I’m not seeing muscle gain?",
      answer:
        "If you’re not seeing muscle gain, try increasing your protein intake slightly and reassess your overall calorie intake, workout routine, and rest. Consult a nutritionist or trainer for personalized guidance.",
    },
  ];

  return (
    <section className="protein-faq-section">
      <h2>FAQs</h2>
      <div className="faq-container" id="faq">
        {faqData.map((faq, index) => (
          <div key={index} className="faq-item">
            <div className="faq-question" onClick={() => handleToggle(index)}>
              {faq.question}
              <span
                className={`faq-arrow ${activeIndex === index ? "rotate" : ""}`}
              ></span>
            </div>
            {activeIndex === index && (
              <div className="faq-answer">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProteinFAQ;
